import { render, staticRenderFns } from "./simple-layout.vue?vue&type=template&id=7fe7b2e5"
import script from "./simple-layout.vue?vue&type=script&lang=js"
export * from "./simple-layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports